export const formatNewSelectEntityProducts = ({
  currentSelectedProductItems,
  selectedProducts,
}: {
  currentSelectedProductItems: any[];
  selectedProducts: any[];
}): any[] => {
  const result = [...currentSelectedProductItems].map((item: any) => {
    const foundSelectedProduct = selectedProducts.find(
      (selectedProduct: any) => selectedProduct.productID == item.productID
    );
    if (foundSelectedProduct) {
      const { absoluteQuantity, relativeQuantity, reportType } =
        foundSelectedProduct.reportQuantity;
      const { priceUnit, priceUnitList } = foundSelectedProduct;

      return {
        ...item,
        ...foundSelectedProduct,
        priceUnit: (priceUnitList ?? item.priceUnit).filter(
          (price: any) => price.isSelected
        ),
        selectedPriceUnit: priceUnit ?? item.selectedPriceUnit,
        oldPriceUnit: priceUnit ?? item.selectedPriceUnit,
        absoluteQuantity,
        relativeQuantity,
        reportType,
        proposalItemID: foundSelectedProduct.proposalItemID,
        productPricePolicyID: foundSelectedProduct.productPricePolicyID,
        productProposalPolicyID: foundSelectedProduct.productProposalPolicyID,
        salePromotionConditions: foundSelectedProduct.salePromotionConditions,
      };
    }

    return item;
  });

  return result;
};
